// components/SearchBar.jsx
import React from 'react';
import { InputBase, styled } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

const Search = styled("div")(() => ({ 
  backgroundColor: "#f2f3f5",
  padding: "6px 16px",
  borderRadius: "16px",
  height: "44px",
  display: "flex",
  alignItems: "center",
}));

const SearchBar = ({ searchText, setSearchText, placeholder = "Search..." }) => {
  return (
    <Search>
      <SearchIcon sx={{ color: 'grey.600', mr: 1, fontSize: '34px' }} />
      <InputBase
        sx={{ fontSize: '22px' }}
        placeholder={placeholder}
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
      />
    </Search>
  )
}

export default SearchBar;
